<template>
  <div class="portfolio-view">
    <NavBar />
    <NavIsland />
    <main class="content-wrapper">
      <PortfolioComponent />
    </main>
  </div>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-facing-decorator';
import NavBar from '@/component/common/NavBar.vue';
import NavIsland from '@/component/common/NavIsland.vue';
import PortfolioComponent from '@/component/project/PortfolioComponent.vue';

@Component({
  components: {
    NavBar,
    NavIsland,
    PortfolioComponent
  }
})
export default class PortfolioView extends Vue {}
</script>

<style scoped>
.portfolio-view {
  min-height: 100vh;
  background-color: var(--ln-bg);
  /* Added padding to avoid content being hidden under fixed navbar if any */
}

.content-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>
